import React, { FC, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';

import { ROUTE } from '~/app/routes';
import { LogoLoading } from '~/elements';
import { redirect, useNavigate } from '~/lib/navigation';
import { isTrustedRedirect } from '~/lib/navigation/redirect';
import { useSessionStore } from '~/stores/Session';
import { setAppsContextCookies } from '~/util';

const TRUSTED_APP_DOMAINS = ['apps.column.com', 'apps.column-staging.com'];

export const PageAppsRedirect: FC = () => {
  const [searchParams] = useSearchParams();
  const navigate = useNavigate();
  const { currentPlatform, currentUser, isLoading, isSandbox } = useSessionStore();
  const redirectUrl = searchParams.get('redirect');
  const platformId = currentPlatform?.id ?? currentUser?.defaultPlatformId;

  useEffect(() => {
    if (!redirectUrl) {
      navigate(ROUTE.ROOT, { replace: true });
      return;
    }

    if (!isTrustedRedirect(redirectUrl, { trustedDomains: TRUSTED_APP_DOMAINS })) {
      navigate(ROUTE.ROOT, { replace: true });
      return;
    }

    if (!platformId) {
      if (!isLoading) {
        navigate(ROUTE.PROFILE, { replace: true });
      }
      return;
    }

    setAppsContextCookies({ platformId, isSandbox: isSandbox ?? true });
    redirect(redirectUrl, { trustedDomains: TRUSTED_APP_DOMAINS });
  }, [isLoading, isSandbox, navigate, platformId, redirectUrl]);

  return <LogoLoading />;
};
